import { Box, Button, Typography, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Header from '../../components/Header';
import { tokens } from '../../theme';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PlaceIcon from '@mui/icons-material/Place';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import PersonIcon from '@mui/icons-material/Person';
import KeyIcon from '@mui/icons-material/Key';
import ChangePassword from '../changePassword';
import WcIcon from '@mui/icons-material/Wc';
import CakeIcon from '@mui/icons-material/Cake';
import MenuBookIcon from '@mui/icons-material/MenuBook';

const PassengerDetails = () => {
  const { id } = useParams();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [passenger, setPassenger] = useState(null);

  const [openPasswordModal, setOpenPasswordModal] = useState(false);
  const handleOpenPasswordModal = () => setOpenPasswordModal(true);
  const handleClosePasswordModal = () => setOpenPasswordModal(false);

  const token = localStorage.getItem('token');

  const getPassengerDetails = async () => {
    const res = await fetch(`${process.env.REACT_APP_APILINK}/passengers/${id}`, { headers: { token } });
    const data = await res.json();
    if (data.success) {
      setPassenger(data.passenger);
    }
  };

  useEffect(() => {
    getPassengerDetails();
  }, []);

  // Function to convert backend date to 'DD-MM-YYYY' format
  const convertDate = (backendDate) => {
    const dateObject = new Date(backendDate);
    const day = String(dateObject.getDate()).padStart(2, '0');
    const month = String(dateObject.getMonth() + 1).padStart(2, '0');
    const year = dateObject.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <>
      {passenger && (
        <Box m="20px">
          <Box display="flex" justifyContent="space-between" alignItems="center" gap="10px" flexWrap="wrap">
            <Header title={`${passenger.name} ${passenger.surname}`} subtitle="Passenger Details" />

            <Box display="flex" gap="10px" flexWrap="wrap" mb="20px">
              <Link to="/allpassengers">
                <Button
                  sx={{
                    backgroundColor: colors.blueAccent[700],
                    color: colors.grey[100],
                    fontSize: '14px',
                    fontWeight: 'bold',
                    padding: '10px 20px',
                    '&:hover': {
                      backgroundColor: colors.blueAccent[800],
                    },
                  }}
                >
                  Go Back
                </Button>
              </Link>
            </Box>
          </Box>

          <Box backgroundColor={colors.primary[400]} borderRadius={5} p="1.5rem">
            {/* Passenger Details */}
            <Box display="flex" flexDirection="column" gap="10px" mb="2rem">
              <Typography variant="h2" fontWeight={'bold'} color={colors.grey[100]} mb="5px">
                Passenger Details
              </Typography>

              <Box display="flex" gap="10px" flexWrap="wrap">
                <Box
                  flex={1}
                  border={1}
                  borderColor={colors.primary[300]}
                  borderRadius="8px"
                  p="10px"
                  sx={{ '&:hover': { backgroundColor: '#2D3B55' } }}
                >
                  <Typography variant="h5" color={colors.greenAccent[500]} display="flex" alignItems="center" gap="5px">
                    <PersonIcon /> Name
                  </Typography>
                  <Typography variant="h4" sx={{ color: colors.grey[100] }}>
                    {passenger?.name}
                  </Typography>
                </Box>

                <Box
                  flex={1}
                  border={1}
                  borderColor={colors.primary[300]}
                  borderRadius="8px"
                  p="10px"
                  sx={{ '&:hover': { backgroundColor: '#2D3B55' } }}
                >
                  <Typography variant="h5" color={colors.greenAccent[500]} display="flex" alignItems="center" gap="5px">
                    <PersonIcon /> Surname
                  </Typography>
                  <Typography variant="h4" sx={{ color: colors.grey[100] }}>
                    {passenger?.surname}
                  </Typography>
                </Box>
              </Box>

              <Box display="flex" gap="10px" flexWrap="wrap">
                <Box
                  flex={1}
                  border={1}
                  borderColor={colors.primary[300]}
                  borderRadius="8px"
                  p="10px"
                  sx={{ '&:hover': { backgroundColor: '#2D3B55' } }}
                >
                  <Typography variant="h5" color={colors.greenAccent[500]} display="flex" alignItems="center" gap="5px">
                    <MailOutlineIcon /> Email
                  </Typography>
                  <Typography variant="h4" sx={{ color: colors.grey[100] }}>
                    {passenger?.email}
                  </Typography>
                </Box>

                <Box
                  flex={1}
                  border={1}
                  borderColor={colors.primary[300]}
                  borderRadius="8px"
                  p="10px"
                  sx={{ '&:hover': { backgroundColor: '#2D3B55' } }}
                >
                  <Typography variant="h5" color={colors.greenAccent[500]} display="flex" alignItems="center" gap="5px">
                    <LocalPhoneIcon /> Phone Number
                  </Typography>
                  <Typography variant="h4" sx={{ color: colors.grey[100] }}>
                    {passenger?.phone}
                  </Typography>
                </Box>
              </Box>

              <Box display="flex" gap="10px" flexWrap="wrap">
                <Box
                  flex={1}
                  border={1}
                  borderColor={colors.primary[300]}
                  borderRadius="8px"
                  p="10px"
                  sx={{ '&:hover': { backgroundColor: '#2D3B55' } }}
                >
                  <Typography variant="h5" color={colors.greenAccent[500]} display="flex" alignItems="center" gap="5px">
                    <WcIcon /> Gender
                  </Typography>
                  <Typography variant="h4" sx={{ color: colors.grey[100] }}>
                    {passenger.gender
                      ? passenger.gender === 'm'
                        ? 'Male'
                        : passenger.gender === 'f'
                        ? 'Female'
                        : 'Other'
                      : null}
                  </Typography>
                </Box>

                <Box
                  flex={1}
                  border={1}
                  borderColor={colors.primary[300]}
                  borderRadius="8px"
                  p="10px"
                  sx={{ '&:hover': { backgroundColor: '#2D3B55' } }}
                >
                  <Typography variant="h5" color={colors.greenAccent[500]} display="flex" alignItems="center" gap="5px">
                    <CakeIcon /> Date of Birth
                  </Typography>
                  <Typography variant="h4" sx={{ color: colors.grey[100] }}>
                    {passenger.dob && convertDate(passenger.dob)}
                  </Typography>
                </Box>
              </Box>

              <Box
                border={1}
                borderColor={colors.primary[300]}
                borderRadius="8px"
                p="10px"
                sx={{ '&:hover': { backgroundColor: '#2D3B55' } }}
              >
                <Typography variant="h5" color={colors.greenAccent[500]} display="flex" alignItems="center" gap="5px">
                  <MenuBookIcon /> Passport
                </Typography>
                <Typography variant="h4" sx={{ color: colors.grey[100] }}>
                  {passenger?.passport}
                </Typography>
              </Box>

              <Box
                border={1}
                borderColor={colors.primary[300]}
                borderRadius="8px"
                p="10px"
                sx={{ '&:hover': { backgroundColor: '#2D3B55' } }}
              >
                <Typography variant="h5" color={colors.greenAccent[500]} display="flex" alignItems="center" gap="5px">
                  <PlaceIcon /> Address
                </Typography>
                <Typography variant="h4" sx={{ color: colors.grey[100] }}>
                  {passenger?.address}
                </Typography>
              </Box>

              <Button
                onClick={handleOpenPasswordModal}
                sx={{
                  backgroundColor: colors.blueAccent[700],
                  color: colors.grey[100],
                  fontSize: '14px',
                  fontWeight: 'bold',
                  padding: '10px 20px',
                  width: 'fit-content',
                  '&:hover': {
                    backgroundColor: colors.blueAccent[800],
                  },
                }}
              >
                <KeyIcon sx={{ mr: '10px' }} /> Change Password
              </Button>

              <ChangePassword open={openPasswordModal} handleClose={handleClosePasswordModal} id={id} />
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default PassengerDetails;
